<template>
  <div class="goods-status">
    <div class="sale-ended" v-if="leftSecsEnd < 1">
    <p>非常感谢您的关注和支持，本次双11活动已结束，如果需要了解更多斗K，可<a :href="urlKline" class="blue">点击查看更多&gt;&gt;</a></p>
    </div>
    <goods-last-status v-else-if="isLast(goodsId && isPayed(goodsId))" :goods-id="goodsId" />
    <goods-pre-status v-else-if="isLast(goodsId) && !isPayed(goodsId)" :goods-id="toPreId(goodsId)" />
    <goods-pre-status v-else-if="isPre(goodsId)" :goods-id="goodsId" />
  </div>
</template>

<script>
  import {
    mapGetters
  } from 'vuex';

  export default {
    props: ['goodsId'],
    computed: {
      ...mapGetters(['isPre', 'isLast', 'myGidLast', 'myGidPre', 'goodInfo', 'leftSecsEnd', 'urlKline', 'toPreId', 'isPayed'])
    }
  }
</script>
